export default "../media/map_icon.3096ceeb5c05431588735f9e000186ea.svg";